import React from 'react';
import styles from './styles';
import LinkIcons from "./LinkIcons";


const UserInfo = props => {

  const [copied, setCopided] = React.useState(false)

  const copy = (e) => {
    const textField = document.createElement('textarea');
    textField.innerText = props.user.email;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    setCopided(true)
  }

  if(copied) setTimeout(() => setCopided(false), 1500)

  return(
    <ul style={styles.list}>
      <li style={styles.listItem}>
        <LinkIcons name="user" size='sm' />
        {props.user.name}
      </li>
      <li style={styles.listItem}>
        <LinkIcons name="emailRecords" size='sm' />
        <span onClick={copy}>{copied ? 'Copied to clipboard' : props.user.email}</span>
      </li>
    </ul>
  )
}

export default UserInfo;
